import { useRemoteConfig, createFlagsSchema, schema } from '@funtech-int/yango-shared';

import { clientConfig } from '@/config/client';

const { legalLink: defaultLegalLink } = clientConfig;

const legalScheme = createFlagsSchema({
    legal: schema.arrayOf(schema.create({ id: schema.string, link: schema.string })).optional(),
});

export const useLegal = () => {
    const remoteConfig = useRemoteConfig(legalScheme);

    const legal = remoteConfig.get('legal');

    return legal?.find((entry) => entry.id === 'agreement')?.link ?? defaultLegalLink;
};
